import { useState, useEffect } from "react";
import DiagramCard, { isRenderableDiagram } from "@/components/DiagramCard";
import { Section } from "./shared";

export function DiagramsSection({ diagrams }) {
  const [renderable, setRenderable] = useState(null); // null = still validating

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const results = await Promise.all(diagrams.map(isRenderableDiagram));
      if (!cancelled) {
        setRenderable(diagrams.filter((_, i) => results[i]));
      }
    })();
    return () => { cancelled = true; };
  }, [diagrams]);

  if (!renderable || renderable.length === 0) return null;

  return (
    <Section label="Diagrams">
      <div className="grid sm:grid-cols-2 gap-3">
        {renderable.map((d, i) => (
          <DiagramCard key={i} diagram={d} />
        ))}
      </div>
    </Section>
  );
}
